import React, { Component } from 'react';
import { Modal } from 'antd';
import { store } from 'Store/store.index';
import {isMobile} from 'Utils/device';
import './advertDialog.scss';
class AdvertDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  } 

  handlerAdvert = () => {
    const { advertInfo } = store.advertStore
    window.open(advertInfo.url)
  }

  close = (e) => {
    store.advertStore.advertDialogHide()
    e.stopPropagation()
  }

  hyperLink = () => {
    const { advertInfo } = store.advertStore
    store.advertStore.advertDialogHide()
    window.open(advertInfo.hyperLink)
  }

  render() {
    const { advertDialog, advertInfo } = store.advertStore
    return (
      <React.Fragment>
        <div>
          {
            !isMobile && <Modal
              width='auto'
              className= "advertDialog"
              visible={ advertDialog && !!advertInfo }
              closable={false}
              title= ""
            >
              <div className='advertBox' /*style={{backgroundImage: `url(${advertInfo.url})`}}*/ >
                <img src={advertInfo.url} onClick={() => {this.hyperLink()}}/>
                <span className='advertClose' onClick={this.close}></span>
              </div>
              {/* <img  src={advertInfo.img} alt="提示" onClick={() => {this.handlerAdvert}} /> */}
            </Modal>
          }
        </div>
      </React.Fragment>
    )
  }
}
export default AdvertDialog;
